<template>
  <div class="rotation-page">
    <div class="container-rotation">
      <div class="rotation-title">
        <div class="flexC">
          <p class="triggerif-add">触发条件</p>
          <p @click="returnBack" style="margin-left: 20px; cursor: pointer">
            <i class="el-icon-caret-left"></i>
            <span>返回</span>
          </p>
        </div>
        <el-button
          @click="handleAddTime"
          size="small"
          type="primary"
          v-if="controlType == 0"
          >+定时条件</el-button
        >
        <el-button
          @click="handleAddCondition"
          size="small"
          type="primary"
          v-if="controlType == 1"
          >+自动条件</el-button
        >
      </div>
      <ul class="triggerif">
        <!-- 定时条件 -->
        <div class="container-content tablecontent" v-if="controlType == 0">
          <el-table
            :data="timeTableData"
            style="width: 100%"
            :header-cell-style="{ background: '#F6F6F6' }"
            v-loading="isloading"
          >
            <el-table-column label="开始时间" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.startTime }}</p>
              </template>
            </el-table-column>
            <el-table-column label="结束时间" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.endTime }}</p>
              </template>
            </el-table-column>
            <el-table-column label="定时类型" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.timeType | timeType }}</p>
              </template>
            </el-table-column>
            <el-table-column label="定时时间" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.timeType == 0">
                  {{ scope.row.executionWeek | executionWeek }}
                </p>
                <p v-if="scope.row.timeType == 1">
                  {{ scope.row.executionDate }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150px">
              <template slot-scope="scope">
                <a class="td-opption" @click="handleUpdateTime(scope.row.id)"
                  >编辑</a
                >
                <a class="td-opption del" @click="handleDelTime(scope.row.id)"
                  >删除</a
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 自动条件 -->
        <div class="container-content tablecontent" v-if="controlType == 1">
          <el-table
            :data="conditionTableData"
            style="width: 100%"
            :header-cell-style="{ background: '#F6F6F6' }"
            v-loading="isloading"
          >
            <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.type | devicetype }}</p>
              </template>
            </el-table-column>
            <el-table-column label="设备名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="属性名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="自动条件" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.condition }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150px">
              <template slot-scope="scope">
                <a
                  class="td-opption"
                  @click="handleUpdateCondition(scope.row.id)"
                  >编辑</a
                >
                <a
                  class="td-opption del"
                  @click="handleDelCondition(scope.row.id)"
                  >删除</a
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </ul>
      <!-- 开关配置 -->
      <div class="rotation-title">
        <p class="triggerif-add">开关配置</p>
        <el-button @click="handleAddAction" size="small" type="primary"
          >+开关配置</el-button
        >
      </div>
      <el-table
        :data="actionTableData"
        style="width: 100%"
        :header-cell-style="{ background: '#F6F6F6' }"
      >
        <el-table-column label="设备名称" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.deviceName }}</p>
          </template>
        </el-table-column>
        <el-table-column label="属性名称" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.attributeName }}</p>
          </template>
        </el-table-column>
        <el-table-column label="执行动作" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.executionAction }}</p>
          </template>
        </el-table-column>
        <el-table-column label="动作时长" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.intervalTime }}</p>
          </template>
        </el-table-column>
        <el-table-column label="执行顺序" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.orderNum }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <a
              class="td-opption"
              style="margin: 0 10px"
              @click="handleUpdateAction(scope.row.id)"
              >编辑</a
            >
            <a
              class="td-opption del"
              style="margin: 0 10px"
              @click="handleDelAction(scope.row.id)"
              >删除</a
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="rotation-title" style="margin-top: 50px">
        <p class="triggerif-add">轮灌组</p>
        <el-button @click="handleAddRotation" size="small" type="primary"
          >+ 轮灌组</el-button
        >
      </div>
      <ul class="grop_ul">
        <li class="grop_li">
          <span class="grop_title gw1">轮灌组名称</span>
          <span class="grop_title gw2">触发条件</span>
          <span class="grop_title gw3">开关配置</span>
          <span class="grop_title gw4">执行方式</span>
          <span class="grop_title gw5">操作</span>
        </li>
        <li
          class="grop_li"
          v-for="(item, index) in rotationTableData"
          :key="item.id"
        >
          <div class="grop_val gw1">
            <el-input
              class="w1"
              v-model="item.title"
              placeholder="请输入轮灌组名称"
              maxlength="10"
            ></el-input>
          </div>
          <div class="grop_val gw2">
            <el-select
              collapse-tags
              multiple
              class="w1"
              v-model="item.tj"
              placeholder="请选择触发条件"
            >
              <el-option
                v-for="i in triggerConditionArray"
                :key="i.triggerId"
                :label="i.triggerCondition"
                :value="i.triggerId"
              ></el-option>
            </el-select>
          </div>
          <div class="grop_val gw3">
            <el-select
              collapse-tags
              multiple
              class="w1"
              v-model="item.switchIds"
              placeholder="请选择开关配置"
            >
              <el-option
                v-for="i in actionTableData"
                :key="i.value"
                :label="i.lableText"
                :value="i.id"
              ></el-option>
            </el-select>
          </div>

          <div class="grop_val gw4">
            <el-select
              class="w1"
              v-model="item.executionType"
              placeholder="请选择执行方式"
            >
              <el-option label="依次" value="0"></el-option>
              <el-option label="同时" value="1"></el-option>
            </el-select>
          </div>
          <div class="grop_val grop_op gw5">
            <img
              v-if="index != 0"
              @click="handleUpRotation(index)"
              class="grop_icon"
              src="../../assets/images/top.png"
              alt
            />
            <img
              v-if="rotationTableData.length - 1 != index"
              @click="handleDownRotation(index)"
              class="grop_icon"
              src="../../assets/images/bottom.png"
              alt
            />
            <img
              @click="handleDelRotation(index)"
              class="grop_icon"
              src="../../assets/images/del.png"
              alt
            />
          </div>
        </li>

        <li style="display: flex; justify-content: center">
          <el-button
            @click="handleSaveRotation()"
            type="primary"
            style="margin: 50px 0"
            >保存</el-button
          >
        </li>
      </ul>
      <!-- 添加编辑定时条件-定时 -->
      <el-dialog
        :title="timeForm.id ? '编辑定时条件' : '添加定时条件'"
        :visible.sync="timeDialog"
        width="880px"
        :before-close="handleCloseTime"
      >
        <div class="equipmentcenter-opption-box">
          <el-form
            :inline="true"
            ref="timeForm"
            :rules="timeRules"
            :model="timeForm"
            label-width="100px"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="开始时间：" prop="startTime">
                  <el-time-picker
                    v-model="timeForm.startTime"
                    :picker-options="{
                      selectableRange:
                        '00:00:00 - ' +
                        (timeForm.endTime ? timeForm.endTime : '23:59:59'),
                    }"
                    placeholder="请选择开始时间"
                    value-format="HH:mm:ss"
                    format="HH:mm:ss"
                  ></el-time-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束时间：" prop="endTime">
                  <el-time-picker
                    v-model="timeForm.endTime"
                    :picker-options="{
                      selectableRange:
                        (timeForm.startTime ? timeForm.startTime : '00:00:00') +
                        ' - 23:59:59',
                    }"
                    placeholder="请选择结束时间"
                    value-format="HH:mm:ss"
                    format="HH:mm:ss"
                  ></el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="定时类型：" prop="timeType">
                  <el-select
                    v-model="timeForm.timeType"
                    placeholder="请选择定时类型"
                    style="width: 606px !important"
                  >
                    <el-option label="重复" value="0"></el-option>
                    <el-option label="一次" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="timeForm.timeType == 0">
              <el-col :span="24">
                <el-form-item label="定时周期：" prop="executionWeekArr">
                  <el-select
                    v-model="timeForm.executionWeekArr"
                    multiple
                    placeholder="请选择定时周期"
                    style="width: 606px !important"
                  >
                    <el-option label="周一" value="1"></el-option>
                    <el-option label="周二" value="2"></el-option>
                    <el-option label="周三" value="3"></el-option>
                    <el-option label="周四" value="4"></el-option>
                    <el-option label="周五" value="5"></el-option>
                    <el-option label="周六" value="6"></el-option>
                    <el-option label="周日" value="7"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="timeForm.timeType == 1">
              <el-col :span="24">
                <el-form-item label="定时时间：" prop="executionDate">
                  <el-date-picker
                    v-model="timeForm.executionDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="请选择定时时间"
                    style="width: 606px !important"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              style="text-align: center; margin-top: 20px; display: block"
            >
              <el-button
                type="info"
                style="width: 120px"
                @click="handleCloseTime()"
                >取消</el-button
              >
              <el-button
                type="primary"
                style="width: 120px"
                @click="handleSaveTime()"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 添加编辑自动条件-自动 -->
      <el-dialog
        :title="conditionForm.id ? '编辑自动条件' : '添加自动条件'"
        :visible.sync="conditionDialog"
        width="880px"
        :before-close="handleCloseCondition"
      >
        <div class="equipmentcenter-opption-box">
          <el-form
            :inline="true"
            ref="conditionForm"
            :rules="conditionRules"
            :model="conditionForm"
            label-width="100px"
          >
            <el-form-item label="设备类型：" prop="type">
              <el-select
                v-model="conditionForm.type"
                placeholder="请选择设备类型"
                @change="deviceTypeChange"
                style="width: 587px"
              >
                <el-option label="数值设备" value="0"></el-option>
                <el-option label="开关设备" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称：" prop="eid">
              <el-select
                v-model="conditionForm.eid"
                placeholder="请选择设备名称"
                @change="deviceChange"
                style="width: 587px"
              >
                <el-option
                  v-for="(item, index) in deviceArray"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <ul
              style="position: relative"
              v-for="(item2, index2) in conditionForm.conditionList"
              :key="index2"
            >
              <el-form-item label="属性名称：">
                <el-select
                  v-model="item2.attributeId"
                  placeholder="请选择属性名称"
                  style="width: 160px"
                  @change="attributeChange(index2)"
                >
                  <el-option
                    v-for="(item3, index3) in attributeArray"
                    :key="index3"
                    :label="item3.name"
                    :value="item3.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <div style="display: inline-block">
                <el-form-item
                  v-if="item2.switchType == '-1'"
                  label="大于"
                  label-width="50px !important"
                >
                  <el-input-number
                    placeholder="请输入"
                    v-model="item2.startValue"
                    :min="-99999999"
                    :max="99999999"
                    :precision="2"
                    :step="1"
                    size="small"
                    clearable
                    style="width: 150px !important"
                  ></el-input-number>
                </el-form-item>
                <el-form-item
                  v-if="item2.switchType == '-1'"
                  label="小于"
                  label-width="50px !important"
                >
                  <el-input-number
                    placeholder="请输入"
                    v-model="item2.endValue"
                    :min="-99999999"
                    :max="99999999"
                    :precision="2"
                    :step="1"
                    size="small"
                    clearable
                    style="width: 150px !important"
                  ></el-input-number>
                </el-form-item>
                <el-form-item
                  v-if="item2.switchType == '1' || item2.switchType == '4'"
                  label="大于"
                  label-width="50px !important"
                >
                  <el-input-number
                    placeholder="请输入"
                    v-model="item2.startValue"
                    :min="0"
                    :max="100"
                    :step="1"
                    size="small"
                    clearable
                    style="width: 150px !important"
                  ></el-input-number>
                </el-form-item>
                <el-form-item
                  v-if="item2.switchType == '1' || item2.switchType == '4'"
                  label="小于"
                  label-width="50px !important"
                >
                  <el-input-number
                    placeholder="请输入"
                    v-model="item2.endValue"
                    :min="0"
                    :max="100"
                    :step="1"
                    size="small"
                    clearable
                    style="width: 150px !important"
                  ></el-input-number>
                </el-form-item>
                <el-form-item
                  v-if="
                    item2.switchType == '0' ||
                    item2.switchType == '3' ||
                    item2.switchType == '2'
                  "
                >
                  <el-select
                    v-model="item2.startValue"
                    placeholder="请选择"
                    class="select-class2"
                  >
                    <el-option label="开启" value="1"></el-option>
                    <el-option label="关闭" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="item2.switchType == '5'">
                  <el-select
                    v-model="item2.startValue"
                    placeholder="请选择"
                    class="select-class2"
                  >
                    <el-option label="停止" value="0"></el-option>
                    <el-option label="正开" value="1"></el-option>
                    <el-option label="反开" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="item2.switchType == '6'">
                  <el-select
                    v-model="item2.switchType.startValue"
                    placeholder="请选择"
                    class="select-class2"
                  >
                    <el-option label="展开停止" value="0"></el-option>
                    <el-option label="收缩停止" value="1"></el-option>
                    <el-option label="展开" value="2"></el-option>
                    <el-option label="收缩" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="item2.switchType == '7'">
                  <el-select
                    v-model="item2.switchType.startValue"
                    placeholder="请选择"
                    class="select-class2"
                  >
                    <el-option label="下发" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="item2.switchType == '8'">
                  <el-select
                    v-model="item2.startValue"
                    placeholder="请选择"
                    class="select-class2"
                  >
                    <el-option
                      v-for="(item4, index4) in item2.customSwitchCmds"
                      :key="index4"
                      :label="item4.name"
                      :value="item4.id + ''"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <a class="a-class2" @click="delAttribute(index2)">删除</a>
            </ul>
            <el-form-item>
              <a class="td-opption" @click="addAttribute()">+添加动作属性</a>
            </el-form-item>
            <el-form-item
              style="text-align: center; margin-top: 20px; display: block"
            >
              <el-button
                type="info"
                style="width: 120px"
                @click="handleCloseCondition()"
                >取消</el-button
              >
              <el-button
                type="primary"
                style="width: 120px"
                @click="handleSaveCondition()"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 添加编辑开关配置-动作 -->
      <el-dialog
        :title="actionForm.id ? '编辑开关配置' : '添加开关配置'"
        :visible.sync="actionDialog"
        width="880px"
        :before-close="handleCloseAction"
      >
        <div class="equipmentcenter-opption-box">
          <el-form
            :inline="true"
            ref="actionForm"
            :rules="actionRules"
            :model="actionForm"
            label-width="100px"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="动作设备：" prop="actionDeviceIndex">
                  <el-select
                    v-model="actionForm.actionDeviceIndex"
                    placeholder="请选择动作设备"
                    style="width: 606px !important"
                    @change="actionDeviceChange"
                  >
                    <el-option
                      v-for="(item, index) in actionDeviceArray"
                      :key="index"
                      :label="item.deviceName + '_' + item.attributeName"
                      :value="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="动作开度："
                  prop="executionValue"
                  v-if="
                    actionForm.switchType == 1 || actionForm.switchType == 4
                  "
                >
                  <el-input-number
                    placeholder="请输入动作开度"
                    v-model="actionForm.executionValue"
                    size="small"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="100"
                    style="width: 606px !important"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="动作状态：" prop="executionValue" v-else>
                  <el-select
                    v-if="
                      actionForm.switchType == 0 || actionForm.switchType == 3
                    "
                    v-model="actionForm.executionValue"
                    placeholder="请选择动作状态"
                    style="width: 606px !important"
                  >
                    <el-option label="关闭" :value="0"></el-option>
                    <el-option label="开启" :value="1"></el-option>
                  </el-select>
                  <el-select
                    v-if="actionForm.switchType == 5"
                    v-model="actionForm.executionValue"
                    placeholder="请选择动作状态"
                    style="width: 606px !important"
                  >
                    <el-option label="停止" value="0"></el-option>
                    <el-option label="正开" value="1"></el-option>
                    <el-option label="反开" value="2"></el-option>
                  </el-select>
                  <el-select
                    v-if="actionForm.switchType == 6"
                    v-model="actionForm.executionValue"
                    placeholder="请选择动作状态"
                    style="width: 606px !important"
                  >
                    <el-option label="展开停止" value="0"></el-option>
                    <el-option label="收缩停止" value="1"></el-option>
                    <el-option label="展开" value="2"></el-option>
                    <el-option label="收缩" value="3"></el-option>
                  </el-select>
                  <el-select
                    v-if="actionForm.switchType == 7"
                    v-model="actionForm.executionValue"
                    placeholder="请选择动作状态"
                    style="width: 606px !important"
                  >
                    <el-option label="下发" value="0"></el-option>
                  </el-select>
                  <el-select
                    v-if="actionForm.switchType == 8"
                    v-model="actionForm.executionValue"
                    placeholder="请选择动作状态"
                    style="width: 606px !important"
                  >
                    <el-option
                      v-for="(item, index) in actionForm.customSwitchCmds"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="动作时长：" prop="intervalTime">
                  <el-input-number
                    placeholder="请输入动作时长（秒）"
                    v-model="actionForm.intervalTime"
                    size="small"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999"
                    style="width: 606px !important"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="执行顺序：" prop="orderNum">
                  <el-input-number
                    placeholder="请输入执行顺序"
                    v-model="actionForm.orderNum"
                    size="small"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999"
                    style="width: 606px !important"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              style="text-align: center; margin-top: 20px; display: block"
            >
              <el-button
                type="info"
                style="width: 120px"
                @click="handleCloseAction()"
                >取消</el-button
              >
              <el-button
                type="primary"
                style="width: 120px"
                @click="handleSaveAction()"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "rotation",
  data() {
    return {
      timeTableData: [], // 定时条件table
      timeForm: {
        // 定时条件表单
        id: "",
        linkageControlId: "",
        startTime: "",
        endTime: "",
        timeType: "0",
        executionWeek: "",
        executionWeekArr: [],
        executionDate: "",
      },
      timeRules: {
        // 定时条件表单规则
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "change",
          },
        ],
        timeType: [
          {
            required: true,
            message: "请选择定时类型",
            trigger: "change",
          },
        ],
        executionWeekArr: [
          {
            required: true,
            message: "请选择定时周期",
            trigger: "change",
          },
        ],
        executionDate: [
          {
            required: true,
            message: "请选择定时时间",
            trigger: "change",
          },
        ],
      },
      timeDialog: false, // 定时条件是否显示
      conditionTableData: [], // 自动条件table
      conditionForm: {
        // 自动条件表单
        id: "",
        linkageControlId: "",
        type: "",
        eid: "",
        conditionList: [
          {
            linkageControlId: "",
            type: "0",
            eid: "",
            attributeId: "",
            startValue: undefined,
            endValue: undefined,
            switchType: "-1",
          },
        ],
      },
      conditionRules: {
        // 自动条件表单规则
        type: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        eid: [
          {
            required: true,
            message: "请选择设备名称",
            trigger: "change",
          },
        ],
      },
      conditionDialog: false, // 自动条件是否显示
      deviceArray: [], // 设备集合
      attributeArray: [], // 属性集合
      actionTableData: [], // 开关配置table
      actionForm: {
        // 开关配置表单
        id: "",
        linkageControlId: "",
        controlType: 0,
        type: 3,
        eid: "",
        attributeId: "",
        sendType: 0,
        intervalTime: undefined,
        executionValue: "",
        actionDeviceIndex: undefined, // 选中动作设备索引
        switchType: 0, // 开关类型
        customSwitchCmds: [], // 自定义开关命令数组
        orderNum: "",
      },
      actionRules: {
        // 开关配置表单规则
        actionDeviceIndex: [
          {
            required: true,
            message: "请选择动作设备",
            trigger: "change",
          },
        ],
        intervalTime: [
          {
            required: true,
            message: "请输入动作时长",
            trigger: "blur",
          },
        ],
        executionValue: [
          {
            required: true,
            message: "请选择动作状态",
            trigger: "change",
          },
        ],
        orderNum: [
          {
            required: true,
            message: "请输入执行顺序",
            trigger: "orderNum",
          },
        ],
      },
      actionDialog: false, // 开关配置是否显示
      actionDeviceArray: [], // 动作设备数组
      rotationTableData: [], // 轮罐组表数据
      triggerConditionArray: [], // 触发条件

      linkageControlId: "", // 联动控制id
      controlType: "", // 控制类型
    };
  },
  created() {
    this.linkageControlId = this.$route.query.id;
    this.controlType = this.$route.query.controlType;

    if (this.controlType == 0) {
      // 获取定时条件列表
      this.getTimeList();
    } else {
      // 获取自动条件列表
      this.getConditionList();
    }

    // 获取开关配置列表
    this.getActionList();

    // 获取动作设备列表
    this.getActionDeviceList();

    // 获取轮罐组列表
    this.getRotationList();
  },
  computed: {
    ...mapState("user", ["token"]),
  },
  methods: {
    // 获取定时条件列表
    getTimeList() {
      this.isloading = true;
      this.$api.device
        .getTimeListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            this.timeTableData = res.data;
            this.isloading = false;

            // 获取触发条件列表
            this.getTriggerConditionList();
          }
        });
    },
    // 删除定时条件
    handleDelTime(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun("pc/linkageControl/deleteLinkageControlTime", id)
          .then((res) => {
            if (res.code == 200) {
              // 获取定时条件列表
              this.getTimeList();
              this.$toaster.ok(res.msg);
            } else {
              this.$toaster.error(res.msg);
            }
          });
      });
    },
    // 关闭定时条件窗口
    handleCloseTime() {
      // 清空原数据
      this.timeForm = {
        id: "",
        linkageControlId: "",
        startTime: "",
        endTime: "",
        timeType: "",
        executionWeek: "",
        executionWeekArr: [],
        executionDate: "",
      };
      this.$refs["timeForm"].resetFields();
      this.timeDialog = false;
    },
    // 添加定时条件
    handleAddTime() {
      this.timeDialog = true;
    },
    // 编辑定时条件
    handleUpdateTime(id) {
      this.timeDialog = true;
      this.$api.device.getTimeById(id).then((res) => {
        if (res.code == 200) {
          res.data.timeType =
            res.data.timeType != undefined ? res.data.timeType.toString() : "";
          res.data.executionWeekArr =
            res.data.executionWeek != undefined
              ? res.data.executionWeek.split(",")
              : [];
          this.timeForm = res.data;
        }
      });
    },
    // 保存定时条件
    handleSaveTime() {
      this.$refs["timeForm"].validate((valid) => {
        if (valid) {
          this.timeForm.executionWeek =
            this.timeForm.executionWeekArr.toString();
          this.timeForm.linkageControlId = this.linkageControlId;
          this.$api.device.saveLinkageControlTime(this.timeForm).then((res) => {
            if (res.code == 200) {
              this.$toaster.ok(res.msg);
              this.getTimeList();
              this.handleCloseTime();
            } else {
              this.$toaster.error(res.msg);
            }
          });
        }
      });
    },
    // 获取自动条件列表
    getConditionList() {
      this.isloading = true;
      this.$api.device
        .getConditionListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
              if (
                res.data[i].switchType == 0 ||
                res.data[i].switchType == 3 ||
                res.data[i].switchType == 2
              ) {
                // 基础开关、只读开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "关闭";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "开启";
                }
              } else if (res.data[i].switchType == 5) {
                // 正反转开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "停止";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "正开";
                } else if (res.data[i].startValue == 2) {
                  res.data[i].condition = "反开";
                }
              } else if (res.data[i].switchType == 6) {
                // 展开收缩开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "展开停止";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "收缩停止";
                } else if (res.data[i].startValue == 2) {
                  res.data[i].condition = "展开";
                } else if (res.data[i].startValue == 3) {
                  res.data[i].condition = "收缩";
                }
              } else if (res.data[i].switchType == 7) {
                // 下发开关
                res.data[i].condition = "下发";
              } else if (res.data[i].switchType == 8) {
                // 自定义开关
                res.data[i].condition = res.data[i].switchCmdName;
              } else {
                // 数值设备、模拟开关
                if (res.data[i].endValue == undefined) {
                  res.data[i].condition = "≥" + res.data[i].startValue;
                } else if (res.data[i].startValue == undefined) {
                  res.data[i].condition = "≤" + res.data[i].endValue;
                } else {
                  res.data[i].condition =
                    "≥" + res.data[i].startValue + "且≤" + res.data[i].endValue;
                }
              }
            }
            this.conditionTableData = res.data;
            this.isloading = false;

            // 获取触发条件列表
            this.getTriggerConditionList();
          }
        });
    },
    // 删除自动条件
    handleDelCondition(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun("pc/linkageControl/deleteLinkageControlCondition", id)
          .then((res) => {
            if (res.code == 200) {
              // 获取自动条件列表
              this.getConditionList();
              this.$toaster.ok(res.msg);
            } else {
              this.$toaster.error(res.msg);
            }
          });
      });
    },
    // 关闭自动条件窗口
    handleCloseCondition() {
      // 清空原数据
      this.conditionForm = {
        id: undefined,
        linkageControlId: "",
        type: "",
        eid: "",
        conditionList: [
          {
            linkageControlId: "",
            type: "",
            eid: "",
            attributeId: "",
            startValue: undefined,
            endValue: undefined,
            switchType: "-1",
          },
        ],
      };
      this.$refs["conditionForm"].resetFields();
      this.conditionDialog = false;
    },
    // 添加自动条件
    handleAddCondition() {
      this.conditionDialog = true;
    },
    // 编辑自动条件
    handleUpdateCondition(id) {
      this.conditionForm.id = id;
      this.conditionDialog = true;

      this.$api.device.getConditionById(this.conditionForm.id).then((res) => {
        if (res.code == 200) {
          this.conditionForm.eid = res.data[0].eid;
          this.conditionForm.type = res.data[0].type.toString();
          this.conditionForm.linkageControlId = res.data[0].linkageControlId;
          this.conditionForm.conditionList = [];

          for (var i = 0; i < res.data.length; i++) {
            res.data[i].startValue =
              res.data[i].startValue != undefined
                ? res.data[i].startValue.toString()
                : undefined;
            res.data[i].endValue =
              res.data[i].endValue != undefined
                ? res.data[i].endValue.toString()
                : undefined;

            this.conditionForm.conditionList.push(res.data[i]);
          }

          if (this.conditionForm.type == 0) {
            // 数值
            this.getNumericalList();
            this.getNumericalAttributes();
          } else if (this.conditionForm.type == 3) {
            // 开关
            this.getSwitchList();
            this.getSwitchAttributes();
          }
        }
      });
    },
    // 添加属性
    addAttribute: function () {
      let cope = {
        linkageControlId: "",
        type: "",
        eid: "",
        attributeId: "",
        startValue: undefined,
        endValue: undefined,
        switchType: "-1",
      };
      this.conditionForm.conditionList.push(cope);
    },
    // 删除属性
    delAttribute: function (index) {
      this.conditionForm.conditionList.splice(index, 1);
    },
    // 保存自动条件
    handleSaveCondition() {
      this.$refs["conditionForm"].validate((valid) => {
        if (!valid) {
          this.$toaster.error("请填写完整的信息");
          return;
        }

        let length = this.conditionForm.conditionList.length;
        if (length == 0) {
          this.$toaster.error("请至少添加一个动作属性");
          return;
        }

        for (var i = 0; i < length; i++) {
          this.conditionForm.conditionList[i].type = this.conditionForm.type;
          this.conditionForm.conditionList[i].eid = this.conditionForm.eid;
          this.conditionForm.conditionList[i].linkageControlId =
            this.linkageControlId;
          this.conditionForm.conditionList[i].controlType = this.controlType;

          if (this.conditionForm.conditionList[i].attributeId == "") {
            this.$toaster.error("请选择动作属性");
            return;
          }

          if (
            this.conditionForm.conditionList[i].switchType == "-1" ||
            this.conditionForm.conditionList[i].switchType == "1" ||
            this.conditionForm.conditionList[i].switchType == "4"
          ) {
            // 数值设备、模拟设备
            if (
              (this.conditionForm.conditionList[i].startValue === undefined ||
                this.conditionForm.conditionList[i].startValue === "") &&
              (this.conditionForm.conditionList[i].endValue === undefined ||
                this.conditionForm.conditionList[i].endValue === "")
            ) {
              this.$toaster.error("大于小于至少输入一个");
              return;
            }

            if (
              this.conditionForm.conditionList[i].startValue !== undefined &&
              this.conditionForm.conditionList[i].startValue !== "" &&
              this.conditionForm.conditionList[i].endValue !== undefined &&
              this.conditionForm.conditionList[i].endValue !== "" &&
              this.conditionForm.conditionList[i].startValue >
                this.conditionForm.conditionList[i].endValue
            ) {
              this.$toaster.error("大于数值不能大于小于数值");
              return;
            }
          } else {
            if (
              this.conditionForm.conditionList[i].startValue === undefined ||
              this.conditionForm.conditionList[i].startValue === ""
            ) {
              this.$toaster.error("请选择属性状态");
              return;
            }
          }
        }

        this.conditionForm.token = this.token;
        this.conditionForm.linkageControlId = this.linkageControlId;
        this.$api.device
          .saveLinkageControlCondition(this.conditionForm)
          .then((res) => {
            if (res.code == 200) {
              this.$toaster.ok(res.msg);
              this.handleCloseCondition();
              this.getConditionList();
            }
          });
      });
    },
    // 获取数值设备列表
    getNumericalList() {
      this.$api.device.getDeviceSwtichList2(1, 1000).then((res) => {
        if (res.code == 200) {
          this.deviceArray = [];
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.name = res.data[i].name;
            obj.value = res.data[i].id;
            this.deviceArray.push(obj);
          }
        }
      });
    },
    // 获取开关设备列表
    getSwitchList() {
      this.$api.device.getAllDeviceSwitchs().then((res) => {
        if (res.code == 200) {
          this.deviceArray = [];
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.name = res.data[i].name;
            obj.value = res.data[i].id;
            this.deviceArray.push(obj);
          }
        }
      });
    },
    // 设备类型下来切换
    deviceTypeChange() {
      this.conditionForm.conditionList = [
        {
          linkageControlId: "",
          type: "",
          eid: "",
          attributeId: "",
          startValue: undefined,
          endValue: undefined,
          switchType: "-1",
        },
      ];
      this.conditionForm.eid = "";
      this.deviceArray = [];
      this.attributeArray = [];
      if (this.conditionForm.type == 0) {
        // 数值
        this.getNumericalList();
      } else if (this.conditionForm.type == 3) {
        // 开关
        this.getSwitchList();
      }
    },
    // 设备下拉切换
    deviceChange() {
      this.conditionForm.conditionList = [
        {
          linkageControlId: "",
          type: "",
          eid: "",
          attributeId: "",
          startValue: undefined,
          endValue: undefined,
          switchType: "-1",
        },
      ];
      this.attributeArray = [];
      if (this.conditionForm.type == 0) {
        // 数值
        this.getNumericalAttributes();
      } else if (this.conditionForm.type == 3) {
        // 开关
        this.getSwitchAttributes();
      }
    },
    // 获取数值设备属性列表
    getNumericalAttributes() {
      if (this.conditionForm.eid == "") {
        return;
      }
      this.attributeArray = [];
      this.$api.device
        .getAttributesByEid(this.conditionForm.eid)
        .then((res) => {
          if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.id = res.data[i].id;
              obj.name = res.data[i].cname;
              obj.switchType = -1;
              obj.customSwitchCmds = [];
              this.attributeArray.push(obj);
            }

            // 遍历给条件赋值开关类型
            this.conditionToSwitchType();
          }
        });
    },
    // 获取开关设备属性
    getSwitchAttributes() {
      if (this.conditionForm.eid == "") {
        return;
      }
      this.attributeArray = [];
      this.$api.device
        .getAttributesBySwtichId(this.conditionForm.eid)
        .then((res) => {
          if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.id = res.data[i].id;
              obj.name = res.data[i].cname;
              obj.switchType = res.data[i].switchType;
              obj.customSwitchCmds = res.data[i].customSwitchCmds;
              this.attributeArray.push(obj);
            }

            // 遍历给条件赋值开关类型
            this.conditionToSwitchType();
          }
        });
    },
    // 遍历给条件赋值开关类型
    conditionToSwitchType() {
      var len = this.conditionForm.conditionList.length;
      for (var i = 0; i < len; i++) {
        // 属性下拉切换，处理开关类型以及开关命令
        this.conditionToSingleSwitchType(i);
      }
    },
    // 给条件赋值开关类型
    conditionToSingleSwitchType(index) {
      // 属性id
      var attributeId = this.conditionForm.conditionList[index].attributeId;

      if (this.conditionForm.type == 0) {
        this.conditionForm.conditionList[index].switchType = -1;
      } else if (this.conditionForm.type == 3) {
        this.attributeArray.forEach((val) => {
          if (attributeId == val.id) {
            this.conditionForm.conditionList[index].switchType = val.switchType;
            this.conditionForm.conditionList[index].customSwitchCmds =
              val.customSwitchCmds;
            return true;
          }
        });
      }
    },
    // 属性下拉切换
    attributeChange(index) {
      // 清空属性状态
      this.conditionForm.conditionList[index].startValue = undefined;
      this.conditionForm.conditionList[index].endValue = undefined;
      this.conditionToSingleSwitchType(index);
    },
    // 获取开关配置列表
    getActionList() {
      //获取开关列表
      this.$api.device
        .getActionListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            this.actionTableData = res.data;
            this.actionTableData.forEach((item) => {
              item.lableText = `${item.deviceName}${item.attributeName}${item.intervalTime}s`;

              if (
                item.switchType == 0 ||
                item.switchType == 2 ||
                item.switchType == 3
              ) {
                // 0无状态基础开关、2只读开关 、3有状态基础开关
                if (item.executionValue == 0) {
                  item.executionAction = "关闭";
                } else if (item.executionValue == 1) {
                  item.executionAction = "开启";
                }
              } else if (item.switchType == 1 || item.switchType == 4) {
                // 1无状态模拟开关、4有状态模拟开关
                item.executionAction = "开度：" + item.executionValue;
              } else if (item.switchType == 5) {
                // 5正反转开关
                if (item.executionValue == 0) {
                  item.executionAction = "停止";
                } else if (item.executionValue == 1) {
                  item.executionAction = "正开";
                } else if (item.executionValue == 2) {
                  item.executionAction = "反开";
                }
              } else if (item.switchType == 6) {
                // 6展开收缩开关
                if (item.executionValue == 0) {
                  item.executionAction = "展开停止";
                } else if (item.executionValue == 1) {
                  item.executionAction = "收缩停止";
                } else if (item.executionValue == 2) {
                  item.executionAction = "展开";
                } else if (item.executionValue == 3) {
                  item.executionAction = "收缩";
                }
              } else if (item.switchType == 7) {
                // 7下发开关
                item.executionAction = "下发";
              } else if (item.switchType == 8) {
                // 8自定义开关
                item.executionAction = item.switchCmdName;
              }
            });
          }
        });
    },
    // 删除开关配置
    handleDelAction(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun("pc/linkageControl/deleteLinkageControlAction", id)
          .then((res) => {
            if (res.code == 200) {
              // 获取开关配置列表
              this.getActionList();
              this.$toaster.ok(res.msg);
            } else {
              this.$toaster.error(res.msg);
            }
          });
      });
    },
    // 关闭开关配置窗口
    handleCloseAction() {
      // 清空原数据
      this.actionForm = {
        id: "",
        linkageControlId: "",
        controlType: 0,
        type: 3,
        eid: "",
        attributeId: "",
        sendType: 0,
        intervalTime: undefined,
        executionValue: "",
        actionDeviceIndex: undefined, // 选中动作设备索引
        switchType: 0, // 开关类型
        customSwitchCmds: [], // 自定义开关命令数组
        orderNum: "",
      };
      this.$refs["actionForm"].resetFields();
      this.actionDialog = false;
    },
    // 添加开关配置
    handleAddAction() {
      this.actionDialog = true;
    },
    // 编辑开关配置
    handleUpdateAction(id) {
      this.actionDialog = true;
      this.$api.device.getEquipmentConfigById(id).then((res) => {
        if (res.code == 200) {
          var len = this.actionDeviceArray.length;
          for (var i = 0; i < len; i++) {
            if (
              res.data.eid == this.actionDeviceArray[i].eid &&
              res.data.attributeId == this.actionDeviceArray[i].attributeId
            ) {
              res.data.actionDeviceIndex = i;
              res.data.switchType = this.actionDeviceArray[i].switchType;
              res.data.customSwitchCmds =
                this.actionDeviceArray[i].customSwitchCmds;
              break;
            }
          }

          this.actionForm = res.data;
        }
      });
    },
    // 保存开关配置
    handleSaveAction() {
      this.$refs["actionForm"].validate((valid) => {
        if (valid) {
          this.$api.device
            .saveEquipmentConfig({
              linkageControlId: this.linkageControlId,
              actionList: [
                {
                  id: this.actionForm.id,
                  linkageControlId: this.linkageControlId,
                  controlType: this.controlType,
                  type: 3,
                  eid: this.actionForm.eid,
                  attributeId: this.actionForm.attributeId,
                  sendType: this.actionForm.sendType,
                  intervalTime: this.actionForm.intervalTime,
                  executionValue: this.actionForm.executionValue,
                  orderNum: this.actionForm.orderNum,
                },
              ],
            })
            .then((res) => {
              if (res.code == 200) {
                this.$toaster.ok(res.msg);
                this.getActionList();
                this.handleCloseAction();
              } else {
                this.$toaster.error(res.msg);
              }
            });
        }
      });
    },
    // 获取动作设备列表
    getActionDeviceList() {
      this.$api.device
        .getDeviceByEquipmentId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            this.actionDeviceArray = res.data;
          }
        });
    },
    // 动作设备下拉切换
    actionDeviceChange() {
      var device = this.actionDeviceArray[this.actionForm.actionDeviceIndex];
      this.actionForm.eid = device.eid;
      this.actionForm.attributeId = device.attributeId;
      this.actionForm.switchType = device.switchType;
      this.actionForm.customSwitchCmds = device.customSwitchCmds;
      this.actionForm.executionValue = undefined;
    },
    // 获取轮罐组列表
    getRotationList() {
      this.$api.device
        .getRotationalIrrigationList({
          controlId: this.linkageControlId,
          controlType: this.controlType,
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.rotationTableData.push({
                id: val.id,
                title: val.title,
                tj:
                  this.controlType == 0
                    ? val.linkageControlTimeId
                      ? val.linkageControlTimeId
                      : []
                    : val.linkageControlConditionId
                    ? val.linkageControlConditionId
                    : [],
                switchIds: val.switchDevices ? val.switchDevices : [],
                executionType:
                  val.executionType != undefined
                    ? val.executionType.toString()
                    : "",
              });
            });
          }
        });
    },
    // 上移轮罐组
    handleUpRotation(index) {
      if (index === 0) {
        return;
      }
      //在上一项插入该项
      this.rotationTableData.splice(
        index - 1,
        0,
        this.rotationTableData[index]
      );
      //删除后一项
      this.rotationTableData.splice(index + 1, 1);
    },
    // 下移轮罐组
    handleDownRotation(index) {
      if (index === this.rotationTableData.length - 1) {
        return;
      }
      // 在下一项插入该项
      this.rotationTableData.splice(
        index + 2,
        0,
        this.rotationTableData[index]
      );
      // 删除前一项
      this.rotationTableData.splice(index, 1);
    },
    // 添加轮罐组
    handleAddRotation() {
      var obj = {
        title: "",
        switchIds: [],
        tj: [],
        executionType: "",
        id: "",
      };
      this.rotationTableData.push(obj);
    },
    // 删除轮罐组
    handleDelRotation(index) {
      this.rotationTableData.splice(index, 1);
    },
    // 保存轮罐组
    handleSaveRotation() {
      var dto = {
        controlId: this.linkageControlId,
        controlType: this.controlType,
        irrigationList: [],
      };

      for (let i of this.rotationTableData) {
        if (i.title === "") {
          this.$toaster.error("请输入轮灌组名称");
          return false;
        }

        if (i.tj.length == 0) {
          this.$toaster.error("请选择触发条件");
          return false;
        }

        if (i.switchIds.length == 0) {
          this.$toaster.error("请选择开关配置");
          return false;
        }

        if (i.executionType === "") {
          this.$toaster.error("请选择执行方式");
          return false;
        }

        var obj = {
          id: i.id,
          title: i.title,
          switchIds: i.switchIds.toString(),
          executionType: i.executionType,
        };

        if (this.controlType == 0) {
          obj.linkageControlTimeId = i.tj.toString();
        } else {
          obj.linkageControlConditionId = i.tj.toString();
        }

        dto.irrigationList.push(obj);
      }
      this.$api.device.saveRotationalIrrigationList(dto).then((res) => {
        if (res.code == 200) {
          this.$toaster.ok(res.msg);
        }
      });
    },
    // 获取触发条件列表
    getTriggerConditionList() {
      this.$api.device
        .getTriggerCondition(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            this.triggerConditionArray = res.data;
          }
        });
    },
    // 返回
    returnBack() {
      this.$router.push({
        name: "fertilizerManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/rotation.scss";
.equipmentcenter-opption-box {
  margin: auto;
  padding: 28px 32px !important;
  box-sizing: border-box !important;
  border-radius: 5px !important;
  border: 2px dashed rgba(204, 219, 255, 0.37) !important;
  .el-select {
    width: 100%;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
}

.a-class2 {
  color: #20a9fd;
  position: absolute;
  top: 10px;
  right: 0px;
  cursor: pointer;
}

.select-class2 {
  width: 160px !important;
}

.td-opption {
  color: #4087f0;
  margin-right: 10px;
}

.flexC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}
</style>